import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Sidebar from "../Component/Sidebar";
import { UserContex } from "../context API/UserContext";
import axios from "axios";
import edit from "./../images/pencil.png";
import delet from "./../images/delete.png";
const ManageClient = ({ logout }) => {
  const [userData, setUserData] = useContext(UserContex);
  const [client, setClient] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    axios
      .get("https://back.waratechnology.com/api/client/getclient")
      .then((res) => {
        console.log(res);
        setClient(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    if (!userData.user) {
      navigate("/login");
    }
  });
  const handleDelete = async(id) => {
    console.log(id)
    await axios
      .delete("https://back.waratechnology.com/api/client/delclient/"+id)
      .then((res) =>{
         console.log(res.data)
         
        })
      .catch((err) => console.log(err));
    window.location.reload();
  };
  return (
    <div className="flex ">
      <Sidebar logout={logout} />
      <div className="container mx-auto p-4 ml-80">
        <h1 className="text-3xl font-bold mb-4">Inbox</h1>

        <div className="mt-4 overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="border-collapse border border-slate-500 bg-gray-200">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Sender
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Email
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Country
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Phone
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Message
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {client.map((data, index) => (
                <tr>
                  <td className="px-6 py-3 text-left text-xs font-medium text-gray-900  tracking-wider border border-slate-700">
                    {data.name}
                  </td>
                  <td className="px-6 py-3 text-left text-xs font-medium text-gray-900  tracking-wider border border-slate-700">
                    {data.email}
                  </td>
                  <td className="px-6 py-3 text-left text-xs font-medium text-gray-900  tracking-wider border border-slate-700">
                    {data.country}
                  </td>
                  <td className="px-6 py-3 text-left text-xs font-medium text-gray-900  tracking-wider border border-slate-700">
                    {data.phone}
                  </td>
                  <td className="px-6 py-3 text-left text-xs font-medium text-gray-900  tracking-wider border border-slate-700">
                    {data.message}
                  </td>
                  <td className="px-6 py-3 text-left text-xs font-medium text-gray-900  tracking-wider border border-l-0 border-t-0 border-slate-700 flex justify-between w-full">
                    <Link
                      to={`/clientreply/${data.id}`}
                      className="py-1 px-2 bg-blue-500 hover:bg-blue-700 rounded-lg font-medium "
                    >
                      Reply
                    </Link>
                    <img src={delet} onClick={(e)=>handleDelete(data.id)} className="w-7 cursor-pointer"/>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ManageClient;
